import React, { useEffect, useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { Dropdown } from "primereact/dropdown";
import Button from "react-bootstrap/Button";
import apis from "../../services/apis";
import { toast } from "react-toastify";
import { customFormDataPost } from "../../helper/api-helper/apiHerlpers";
import { confirmDialog } from "primereact/confirmdialog";
import apiUrls from "../../constants/apiUrls";
import apiCommonParams from "../../constants/apiCommonParams";
import { useSmarkState } from "../../Context/KeycloakContext";
import AppContext from "../../Context/AppContext";

const EditRelease = (props) => {
  const userDetails = useSmarkState();
  const storedToken = localStorage.getItem("keycloakToken");
  const { applicationId, siteId } = useContext(AppContext);

  const [projectId, setProjectId] = useState(null);
  const [selectedProjectPerms, setSelectedProjectPerms] = useState([]);
  const [masterProjects, setMasterProjects] = useState([]);
  const [masterReleaseList, setMasterReleaseList] = useState([]);

  const [showList, setShowList] = useState(props.val);
  const [editRelease, setEditRelease] = useState(false);

  const [releaseName, setReleaseName] = useState("");
  const [release, setRelease] = useState(null);
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getProjects();

    setTimeout(() => {
      const ele = document.getElementsByClassName("modal show");
      if (ele?.length) ele[0].removeAttribute("tabindex");
    }, 0);
  }, []);

  /* ================= PROJECT LIST ================= */
  const getProjects = async () => {
    const projects = await apis.getProjects(
      applicationId,
      siteId,
      userDetails.userId,
      userDetails.isAdminUser,
      storedToken
    );

    const projectPermissions =
      JSON.parse(localStorage.getItem("projectPermissions")) || {};
    const isGlobalAdmin =
      JSON.parse(localStorage.getItem("isGlobalAdmin")) || false;

    const filteredProjects = isGlobalAdmin
      ? projects
      : projects.filter((p) => {
          const perms = projectPermissions[p.value] || [];
          return perms.includes("ER") || perms.includes("DR");
        });

    setMasterProjects(filteredProjects || []);
  };

  /* ================= PROJECT CHANGE ================= */
  const projectDropdownChangeHandler = async (event) => {
    const selectedProjectId = event.value;
    setProjectId(selectedProjectId);

    const projectPermissions =
      JSON.parse(localStorage.getItem("projectPermissions")) || {};
    const isGlobalAdmin =
      JSON.parse(localStorage.getItem("isGlobalAdmin")) || false;

    setSelectedProjectPerms(
      isGlobalAdmin
        ? ["ER", "DR"]
        : projectPermissions[selectedProjectId] || []
    );

    await getReleaseList(selectedProjectId);
  };

  const getReleaseList = async (projectId) => {
    const list = await apis.getReleaseListAllData(
      applicationId,
      siteId,
      projectId,
      storedToken
    );
    setMasterReleaseList(list || []);
  };

  /* ================= EDIT ================= */
  const editReleaseHandler = (item) => {
    setEditRelease(true);
    setShowList(false);
    setRelease(item);
    setReleaseName(item.releaseName);
    setError(false);
  };

  /* ================= DELETE ================= */
  const releaseDeleteConfirm = (item) => {
    confirmDialog({
      message: "Do you want to delete this record? This action will permanently delete all tasks under the associated release.",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => deleteRelease(item.releaseId),
    });
  };

  const deleteRelease = (releaseId) => {
    setIsLoading(true);

    const body = new FormData();
    body.append("swcmTicket", apiCommonParams.swcmTicket);
    body.append("applicationid", applicationId);
    body.append("siteid", siteId);
    body.append("releaseid", releaseId);
    body.append("userid", userDetails.userId);

    customFormDataPost(apiUrls.deleteRelease, body, storedToken)
      .then((response) => {
        setMasterReleaseList((prev) =>
          prev.filter((r) => r.releaseId !== releaseId)
        );
        props.loadMasterReleaseDdl();
        toast.success(response.response);
      })
      .catch(() => toast.error("Error"))
      .finally(() => setIsLoading(false));
  };

  /* ================= UPDATE ================= */
  const submitButtonHandler = (event) => {
    event.preventDefault();

    if (!releaseName.trim()) {
      setError(true);
      return;
    }

    setIsLoading(true);

    const body = new FormData();
    body.append(
      "release",
      JSON.stringify({
        ...release,
        releaseName,
        userModified: apiCommonParams.userModified,
        updatedTime: apiCommonParams.updatedTime,
      })
    );
    body.append("swcmTicket", apiCommonParams.swcmTicket);
    body.append("userid", userDetails.userId);

    customFormDataPost(apiUrls.saveRelease, body, storedToken)
      .then(() => {
        getReleaseList(projectId);
        setEditRelease(false);
        setShowList(true);
        toast.success("Release name updated");
      })
      .catch(() => toast.error("Error"))
      .finally(() => setIsLoading(false));
  };

  const closeListModal = () => {
    if (!isLoading) {
      props.onHideEditReleaseEvent(false);
      setShowList(false);
    }
  };

  /* ================= UI ================= */
  return (
    <>
      {/* LIST MODAL */}
      <Modal show={showList} onHide={closeListModal} backdrop="static">
        <Modal.Header closeButton={!isLoading}>
          <Modal.Title>All Releases for Projects</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Dropdown
            filter
            placeholder="--Select project--"
            value={projectId}
            onChange={projectDropdownChangeHandler}
            options={masterProjects}
            style={{ width: "100%", zIndex: "99999" }}
            disabled={isLoading}
          />

          <hr />

          {projectId && (
            <table className="table">
              <thead>
                <tr>
                  <th>Release name</th>
                  <th style={{ textAlign: "right" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {masterReleaseList.length ? (
                  masterReleaseList.map((x, i) => (
                    <tr key={i}>
                      <td>{x.releaseName}</td>
                      <td style={{ textAlign: "right" }}>
                        {selectedProjectPerms.includes("ER") && (
                          <span onClick={() => editReleaseHandler(x)}>
                            <i className="fas fa-pencil-alt"></i>
                          </span>
                        )}
                        &nbsp;&nbsp;
                        {selectedProjectPerms.includes("DR") && (
                          <span onClick={() => releaseDeleteConfirm(x)}>
                            <i className="fas fa-trash-alt"></i>
                          </span>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={2}>No record found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </Modal.Body>
      </Modal>

      {/* EDIT MODAL */}
      <Modal show={editRelease} onHide={() => !isLoading && setEditRelease(false)} backdrop="static">
        <Modal.Header closeButton={!isLoading}>
          <Modal.Title>Edit Release</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            value={releaseName}
            onChange={(e) => {
              setReleaseName(e.target.value);
              setError(false);
            }}
            className="form-control"
            disabled={isLoading}
          />
          {error && <span className="text-danger">Release name is required</span>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setEditRelease(false)} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant="primary" onClick={submitButtonHandler} disabled={isLoading}>
            {isLoading ? "Saving..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditRelease;
